import React, { useEffect, useState } from 'react';
import { Buffer } from 'buffer';
import './home.scss';
//import { Button } from 'devextreme-react/button';
//import notify from 'devextreme/ui/notify';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { fetchJson } from "../../helpers/api";
//import { useAuth } from 'oidc-react';

export default function Home() {
    const [server, setServer] = useState({});
    //const auth = useAuth();
    const CONFIG = window.CONFIG();

    useEffect(() => {
        fetchJson(CONFIG.IDENTITY_ENDPOINT + "/serverinfo")
            .then(async response => {
                setServer(response);
            })
            .catch(error => {
                console.error(`Error initConfig`, error);
                return Promise.reject(error);
            });
    }, [CONFIG.IDENTITY_ENDPOINT]);

    function decodeToken(token) {
        try {
            if (token == null)
                return undefined;
            else {
                var base64 = token.split(".")[1];
                var jsonString = Buffer.from(base64, 'base64').toString('utf-8');
                return JSON.parse(jsonString);
            }
        }
        catch (ex) {
            console.info(`"Invalid id_token: ${token}`)
            return "invalid id_token" + ex;
        }
    };

    //function getAvantiContext() {
    //    try {
    //        //console.log("auth.userData.profile", auth.userData.profile)
    //        //var base64 = auth.userData.profile.AvantiCtx;
    //        //console.log("base64", base64)
    //        //var jsonString = Buffer.from(base64, 'base64').toString('utf-8');
    //        //console.log("jsonString", jsonString)
    //        //return JSON.parse(jsonString);
    //    }
    //    catch (ex) {
    //        console.info(`Invalid avanti context!`)
    //        console.log(ex)
    //        return {};
    //    }
    //};

    const theme = {
        main: 'line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;',
        error: 'line-height:1.3;color:#66d9ef;background:#272822;overflow:auto;',
        key: 'color:#ffffff;',
        string: 'color:#fd971f;',
        value: 'color:#ffff00;',
        boolean: 'color:#ac81fe;',
    };

    var at = {};
    var it = {}
    var info = '';
    var ctx = {};

    //if (auth && auth.userData) {
    //    at = decodeToken(auth.userData.access_token);
    //    it = decodeToken(auth.userData.id_token);
    //    if (at)
    //        info = (new Date(at.exp * 1000)).toString();
    //    ctx = getAvantiContext();
    //}

    return (
        <React.Fragment>
            <h2 className={'content-block'}>Home</h2>
            {/*<div className={'content-block'}>*/}
            {/*    <div>Token g&uuml;ltig bis: {info}</div>*/}
            {/*    */}{/*<div>Scope: {auth.userData.scope}</div>*/}
            {/*    <h6 className={'smallHeader'}>Access Token</h6>*/}
            {/*    <JSONPretty data={at} theme={theme}></JSONPretty>*/}
            {/*    <h6 className={'smallHeader'}>ID Token</h6>*/}
            {/*    <JSONPretty data={it} theme={theme}></JSONPretty>*/}
            {/*    <h6 className={'smallHeader'}>Avanti Context</h6>*/}
            {/*    <JSONPretty data={ctx} theme={theme}></JSONPretty>*/}
            {/*    <h6 className={'smallHeader'}>Identity Server Info</h6>*/}
            {/*    <JSONPretty data={server} theme={theme}></JSONPretty>*/}
            {/*</div>*/}
        </React.Fragment>
    )
}
